import { request } from "utils";

const url = "request/extend-task-deadline";

export async function callExtendTaskDeadline(payload) {
  return request.post(url, payload);
}

export default callExtendTaskDeadline;
